<script setup>
    import { computed, reactive, ref, watch } from 'vue'
    import utilFunctions from '../../firebase_settings/utils.js'

    //親コンポーネントから受け継いだ端末情報
    const props = defineProps({
        terminalObject: {
            type: Object,
            require: true
        },
        corporateId: {
            type: String,
            default: ''
        }
    });
    const emit = defineEmits(['executeMethod']);
    //親コンポーネントから受け継いだ端末の値を保持するリアクティブオブジェクト
    const reactiveObj = reactive({
        //ドア（端末名）
        TerminalName: '',
        //設置先
        Location: '',
        //親機/子機/単独
        TerminalType: '',
        //接続状態(一時的に実装)
        Connection: ''
    })
    //端末の情報の変化を確認するためのリアクティブオブジェクト
    const reactiveObjFlag = reactive({
        //ドア（端末名）
        TerminalNameFlag: false,
        //設置先
        LocationFlag: false,
        //親機/子機/単独
        TerminalTypeFlag: false,
        //接続状態(一時的に実装)
        ConnectionFlag: false
    })
    //変更するドアの情報を格納するオブジェクト
    let editTerminalObject = {}
    //モーダルウィンドウが閉じるときに実行
    const exitModal = (editFlag) => {
        //モーダルウィンドウが閉じるときに入力されていた情報を全てリセットする
        for(let key in reactiveObj){
            reactiveObj[key] = ''
        }
        //モーダルウィンドウが閉じるときに変更ボタンを非活性化
        document.getElementById('commonButtonEdit').disabled = true;
        nameChangedFlag.value = false
        apiDeviceName.value = ''
        //モーダルウィンドウ外を押下されたときは何もせずに閉じる
        if(!editFlag) {
            emit('executeMethod', false);
        }
        else {
            const modalTerminal = document.getElementById('modalTerminal').value;
            const modalLocation = document.getElementById('modalLocation').value
            const modalTerminalType = document.getElementById('modalTerminalType').value
            const editConnection = document.getElementById('editConnection').value
            //親コンポーネントに変更した情報を渡すためのオブジェクト
            editTerminalObject = {
                'terminalId': props.terminalObject['terminalId'],
                'editTerminalInfo': {
                    'TerminalName': nameChangedFlag.value ? apiDeviceName.value : modalTerminal,
                    'Location': modalLocation,
                    'TerminalType': modalTerminalType,
                    'LatestUpdated': Date.now(),
                    "EntryExit": modalLocation == "内側" ? "退室" : "入室",
                    "Connection": editConnection == "false" ? false : true
                }
            }
            //変更される情報が１つ以上あればモダールを閉じて親コンポーネントに渡す
            emit('executeMethod', true, editTerminalObject);
        }
        return
    }
    //値が更新された際にどのプロパティが変更されたかを検知して変更ボタンを活性化させる
    const inputSomeData = () => {
        //活性判定フラグ
        let disableFlag = true
        for(let key in reactiveObj){
            if((props.terminalObject[key] != reactiveObj[key] && reactiveObj[key] != '') ) {
                reactiveObjFlag[key] = true
            }
            else {
                reactiveObjFlag[key] = false
            }
        }
        //上記で更新したreactiveObjFlagにTrueがあれば活性判定フラグTrueにする
        for(let key in reactiveObjFlag){
            if(reactiveObjFlag[key] == true) {
                disableFlag = false
            }
        }
        //活性判定フラグTrueなら変更ボタンを活性化そうでないなら非活性化
        disableFlag ? document.getElementById('commonButtonEdit').disabled = true : document.getElementById('commonButtonEdit').disabled = false
    }
    //端末名に関する算出プロパティ
    const getTerminalName = computed({
        get: () => {
            if (isCheckingDeviceName.value) return ''
            return reactiveObj.TerminalName || props.terminalObject['TerminalName']
        },
        set: (value) => {
            reactiveObj.TerminalName = value
            document.getElementById('modalTerminal').value = value
        }
    })
    //親子関係に関する算出プロパティ
    const getTerminalType = computed({
        get: () => {
            return props.terminalObject['TerminalType']
        },
        set: (value) => {
            reactiveObj.TerminalType = value
            document.getElementById('modalTerminalType').value = value
        }
    })
    //設置場所に関する算出プロパティ
    const getLocation = computed({
        get: () => {
            return props.terminalObject['Location']
        },
        set: (value) => {
            reactiveObj.Location = value
            document.getElementById('modalLocation').value = value
        }
    })
    //接続状況に関する算出プロパティ
    const getConnection = computed({
        get: () => {
            return props.terminalObject['Connection']
        },
        set: (value) => {
            reactiveObj.Connection = value
            document.getElementById('editConnection').value = value
        }
    })
    //リアクティブオブジェクトの監視
    watch(reactiveObj, () => {
        inputSomeData()
    })
    // tips表示フラグ（タイトル）
    const tipsFlag = ref(false)
    const tipsHover = () => { tipsFlag.value = true }
    const tipsLeave = () => { tipsFlag.value = false }
    const tipsToggle = () => { tipsFlag.value = !tipsFlag.value }
    // tips表示フラグ（端末名）
    const tipsNameFlag = ref(false)
    const tipsNameHover = () => { tipsNameFlag.value = true }
    const tipsNameLeave = () => { tipsNameFlag.value = false }
    const tipsNameToggle = () => { tipsNameFlag.value = !tipsNameFlag.value }
    // 全tips閉じる
    const closeAllTips = () => {
        tipsFlag.value = false
        tipsNameFlag.value = false
        nameChangedTipsFlag.value = false
    }
    // 端末種別に応じたtipsメッセージ
    const tipsMessage = computed(() =>{
        if (props.terminalObject['DeviceType'] === 'SwitchBot') {
            return '施錠までの時間を変更する場合は、SwitchBotアプリ内で「解錠後自動施錠」の時間変更を行ってください'
        } else if (props.terminalObject['DeviceType'] === 'Sesame') {
            return '施錠までの時間を変更する場合は、SESAMEアプリ内で「タイマー式のオートロック」の時間変更を行ってください'
        }
        return ''
    })

    // SwitchBot端末名不一致警告
    const nameChangedFlag = ref(false)
    const nameChangedTipsFlag = ref(false)
    const apiDeviceName = ref('')
    const isCheckingDeviceName = ref(false)
    const authError = ref('')
    const nameChangedHover = () => { nameChangedTipsFlag.value = true }
    const nameChangedLeave = () => { nameChangedTipsFlag.value = false }

    watch(() => props.terminalObject, async (newVal) => {
        if (!newVal || !newVal['DeviceType']) return
        if (newVal['DeviceType'] !== 'SwitchBot' || !newVal['SwitchBotUid'] || !props.corporateId) return
        isCheckingDeviceName.value = true
        authError.value = ''
        try {
            const result = await utilFunctions.callFirebaseFunction('getSwitchBotDeviceName', {
                corporateId: props.corporateId,
                deviceId: newVal['SwitchBotUid']
            })
            const fetchedName = result.data.deviceName
            if (fetchedName.trim() !== newVal['TerminalName'].trim()) {
                nameChangedFlag.value = true
                apiDeviceName.value = fetchedName
                // 入力欄をAPI取得名に更新して変更ボタンを活性化
                getTerminalName.value = fetchedName
            }
        } catch (e) {
            console.error('SwitchBot device check error:', e)
            authError.value = e.code === 'functions/not-found' ? 'not-configured' : 'invalid-credentials'
        } finally {
            isCheckingDeviceName.value = false
        }
    }, { immediate: true })

</script>

<template>
    <div class="modalArea" @click="closeAllTips">
        <div id="modalContent" class="modal">
            <div class="tooltip-wrapper">
                <span class="tooltip-content" v-show="tipsFlag">{{ tipsMessage }}</span>
                <p class="modalTitle">端末情報の変更<img @mouseenter="tipsHover" @mouseleave="tipsLeave" @click.stop="tipsToggle" src="../../assets/tips_icon.svg" class="tips"></p>
            </div>
            <div v-if="authError === 'not-configured'" class="authErrorBanner">
                SwitchBotのトークンとクライアントシークレットが設定されていません。<br><span class="settingsLink" @click="$router.push('/appsettings')">アプリ設定画面</span>から設定してください。
            </div>
            <div v-else-if="authError === 'invalid-credentials'" class="authErrorBanner">
                SwitchBotのトークンまたはクライアントシークレットが正しくありません。<br><span class="settingsLink" @click="$router.push('/appsettings')">アプリ設定画面</span>から再設定してください。
            </div>
            <div class="modalInfo terminal-name-info">
                <p class="terminal-name-label">
                    端末名<img v-if="props.terminalObject['DeviceType'] !== 'Sesame' && !nameChangedFlag && !isCheckingDeviceName" @mouseenter="tipsNameHover" @mouseleave="tipsNameLeave" @click.stop="tipsNameToggle" src="../../assets/tips_icon.svg" class="tips">
                    <span class="tooltip-content tooltip-name" v-show="tipsNameFlag && props.terminalObject['DeviceType'] !== 'Sesame'">端末名を変更する場合は、SwitchBotアプリ内で端末名の変更を行い、本画面で「変更する」ボタンを押してください</span>
                </p>
                <input id="modalTerminal" class="modalTerminal" v-model="getTerminalName" :disabled="props.terminalObject['DeviceType'] !== 'Sesame'" :placeholder="isCheckingDeviceName ? '確認中...' : ''">
                <div v-if="nameChangedFlag && !isCheckingDeviceName" class="name-changed-icon-wrapper">
                    <img @mouseenter="nameChangedHover" @mouseleave="nameChangedLeave" @click.stop="nameChangedTipsFlag = !nameChangedTipsFlag" src="../../assets/red_exmark.png" class="tips">
                    <span class="tooltip-content tooltip-name" v-show="nameChangedTipsFlag">SwitchBotアプリで端末名が変更されています。「変更する」ボタンを押すと反映されます。</span>
                </div>
            </div>
            <div class="modalInfo">
                <p>設置先</p>
                <select id="modalLocation" class="modalLocation" v-model="getLocation">
                    <option value="外側">外側</option>
                    <option value="内側">内側</option>
                </select>
            </div>
            <div class="modalInfo">
                <p>親子設定</p>
                <select id="modalTerminalType" class="modalTerminalType" v-model="getTerminalType">
                    <option value="parent">親機</option>
                    <option value="child">子機</option>
                    <option value="single">単独</option>
                </select>
            </div>
            <div class="modalInfo">
                <p>接続設定</p>
                <select id="editConnection" class="editConnection" v-model="getConnection">
                    <option value="false">接続を解除する</option>
                    <option value="true">接続（を維持）する</option>
                </select>
            </div>
            <button id="commonButtonEdit" @click="exitModal(true)" disabled>変更する</button>
        </div>
        <div class="modalOverlay" @click.self="exitModal(false)"></div>
    </div>
</template>

<style scoped>
    .authErrorBanner {
        background-color: #fdecea;
        color: #c62828;
        border: 1px solid #f44336;
        border-radius: 4px;
        padding: 10px 14px;
        margin-bottom: 12px;
        font-size: 13px;
    }
    .settingsLink {
        text-decoration: underline;
        cursor: pointer;
        color: inherit;
        font-size: inherit;
    }
    .tips {
        cursor: pointer;
        vertical-align: middle;
        margin-left: 6px;
    }
    .terminal-name-info {
        position: relative;
    }
    .name-changed-icon-wrapper {
        position: absolute;
        right: 8%;
        top: 50%;
        transform: translateY(-50%);
    }
    .name-changed-icon-wrapper .tips {
        width: 35px;
        height: 35px;
    }
    .modalTitle {
        text-align: center;
    }
    .tooltip-wrapper {
        position: relative;
    }
    .tooltip-content {
        position: absolute;
        color: white;
        background-color: gray;
        border-radius: 0.5em;
        padding: 5px 10px;
        z-index: 10;
        top: -60px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
    }
    .terminal-name-label {
        position: relative;
        display: flex;
        align-items: center;
        min-width: fit-content;
    }
    .tooltip-name {
        bottom: calc(100% + 8px);
        top: auto;
        left: 0;
        transform: translateX(-40%);
        white-space: normal;
        width: 280px;
        text-align: center;
    }
    .tooltip-content:before {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -12px;
        border: 12px solid transparent;
        border-top: 12px solid gray;
    }
    .modal {
        width: 700px;
        height: 600px;
        top: 50%;
        left: 50%;
    }
    #commonButtonEdit {
        width: 190px;
        height: 70px;
        top: 10%;
        left: 50%;
    }
    @media (max-width: 1150px) {
        .modal {
            width: 85%;
            height: auto;
            display: flex;
            justify-content: left;
            align-items: left;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .modal p {
            padding: 10px 0 10px 0;
        }
        .modalInfo {
            flex-direction: column;
            padding: 0 0 0 0;
            position: relative;
        }
        .modalInfo p {
            position: relative;
            top: 0%;
            width: 100%;
            font-size: 16px;
        }
        #commonButtonEdit {
            margin: 20px 0 20px 0;
            top: 30px;
            height: auto;
        }
        .tooltip-content {
            white-space: normal;
            max-width: 75%;
            top: calc(100% + 5px);
            left: 0;
            transform: none;
        }
        .tooltip-content:before {
            top: auto;
            bottom: 100%;
            border-top: none;
            border-bottom: 12px solid gray;
        }
        .tooltip-name {
            bottom: auto;
            top: calc(100% + 5px);
            left: 0;
            transform: none;
            max-width: 200px;
        }
        .terminal-name-label {
            width: auto;
            min-width: unset;
        }
        .name-changed-icon-wrapper {
            right: 0;
            top: auto;
            bottom: 0;
            transform: none;
            height: 50px;
            display: flex;
            align-items: center;
        }
        .name-changed-icon-wrapper .tooltip-name {
            top: auto;
            bottom: calc(100% + 5px);
            left: auto;
            right: 0;
        }
        .name-changed-icon-wrapper .tooltip-name:before {
            bottom: auto;
            top: 100%;
            border-bottom: none;
            border-top: 12px solid gray;
        }
    }
</style>